export default __webpack_public_path__ + "static/people_05-264a60ae5cb0a2a3c266a0a3c3c2c7dd.png";